import { get } from 'lodash';
import moment from 'moment';
import { getAlertInsights } from '@api/autoInsights';
import { humanize } from '@utils';
import { CURRENT_PRODUCT_MODE } from '@src/utils/constants';
import { MAX_LIMIT } from './Insights';

const TS_FORMAT = 'MMM DD HH:mm';

// round off to nearest day or hour
export const getEndTime = (arg = 'day') => {
  if (arg === 'hour') {
    return moment().startOf('hour').format();
  }
  return moment().subtract(1, 'day').endOf('day').format();
};

export const getDisplayInterval = (duration) => {
  const to = moment(getEndTime('hour'));
  const from = moment(to).subtract(duration, 'days');

  return {
    from: from.format(TS_FORMAT),
    to: to.format(TS_FORMAT),
  };
};

export const getInsightsWithCauseText = (insights, aiAlertsDimensionMapping) => {
  return insights.map((insight) => {
    const values = insight.values.map((value) => {
      const { cause, dimension } = value;
      let causeTxt = cause;

      if (`${cause}`.toLowerCase() === 'unknown') {
        const dimensionDisplay = get(
          aiAlertsDimensionMapping,
          [dimension, 'pulse5Label'],
          dimension,
        );
        causeTxt = `${cause} (${dimensionDisplay})`;
      }

      return { ...value, causeTxt };
    });

    return { ...insight, values };
  });
};

export async function generateAlertExportData(dimensionMapping) {
  const to = getEndTime('hour');
  const resp = await getAlertInsights({
    params: {
      to,
      limit: MAX_LIMIT,
    },
  });

  const { insights = [] } = get(resp, 'data', {});

  const formattedData = getInsightsWithCauseText(
    insights,
    dimensionMapping[CURRENT_PRODUCT_MODE.toLocaleLowerCase()],
  );

  const config = {
    page: {
      key: 'ai-alert-insights',
      title: 'AI Alert Insights',
    },
    sections: [
      {
        key: 'ai-alert-insights',
        title: 'AI Alert Insights',
      },
    ],
  };

  const exportData = {
    sections: {
      'ai-alert-insights': {
        'ai-alert-insights': {
          data: formattedData.map((item) => {
            const { maxCumulativeImpactedUniques, values, alertIds } = item;
            return {
              exportRootCause: values
                .map(({ causeTxt }) => {
                  return causeTxt;
                })
                .join(' | '),
              exportPeakImpactedDevices: humanize(maxCumulativeImpactedUniques, ''),
              exportAlertCount: alertIds.length,
            };
          }),
          headers: [
            {
              title: 'Root Cause',
              key: 'exportRootCause',
            },
            {
              title: 'Peak Impacted Devices',
              key: 'exportPeakImpactedDevices',
            },
            {
              title: 'Alert Count',
              key: 'exportAlertCount',
            },
          ],
          widgetInfo: {
            title: `Auto Insights AI Alert Insights Export ${to}`,
          },
        },
      },
    },
  };

  return {
    config,
    exportData,
  };
}
